import React from 'react';
import { Flex, Heading, Text } from '@adobe/react-spectrum';
import styles from './MustWinsEmptyState.module.scss';

export function MustWinsEmptyState() {
  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      gap="size-200"
      UNSAFE_className={styles.emptyStateContainer}
    >
      <Heading level={3}>No Data Available</Heading>
    </Flex>
  );
}
